import { SlotDto, SlotWebchatMap } from "../../models/slot"
import { OptionType } from "../../components/AsyncSearchableInput/AsyncSearchableInput"
import { SystemSlot } from "../../models/slot"

export const getVisitorFields = (slots: SlotDto[], isForWebchat: boolean, useExtIdAsTitle: boolean): OptionType[] => {
    return slots.map(slot => {
        const parsedSlot = isForWebchat ? parseToVisitorFields(slot) : slot.ExternalId
        const title = useExtIdAsTitle ? parsedSlot : slot.Title
        return { value: parsedSlot, label: title }
    })
}

export const getSlotsFields = (fields: string[], isForWebchat: boolean): string[] => {
    if (isForWebchat) {
        return fields.map(slot => {
            return parseFromVisitorFields(slot)
        })
    }
    return fields
}

const parseToVisitorFields = (slot: SlotDto) => {
    const field = slot.ExternalId
    switch (field) {
        case SystemSlot.FirstName:
            return SlotWebchatMap.sys_firstname
        case SystemSlot.LastName:
            return SlotWebchatMap.sys_lastname
        case SystemSlot.MiddleName:
            return SlotWebchatMap.sys_middlename
        case SystemSlot.Contract:
            return SlotWebchatMap.sys_contract
        case SystemSlot.BirthDate:
            return SlotWebchatMap.sys_birthdate
        case SystemSlot.Email:
            return SlotWebchatMap.sys_email
        case SystemSlot.Phone:
            return SlotWebchatMap.sys_phone
        case SystemSlot.OmniUserId:
            return SlotWebchatMap.sys_omniuserid
        case SystemSlot.ExtUserId:
            return SlotWebchatMap.sys_extuserid
        default:
            return field
    }
}

export const parseFromVisitorFields = (field: string) => {
    switch (field) {
        case SlotWebchatMap.sys_firstname:
            return SystemSlot.FirstName
        case SlotWebchatMap.sys_lastname:
            return SystemSlot.LastName
        case SlotWebchatMap.sys_middlename:
            return SystemSlot.MiddleName
        case SlotWebchatMap.sys_contract:
            return SystemSlot.Contract
        case SlotWebchatMap.sys_birthdate:
            return SystemSlot.BirthDate
        case SlotWebchatMap.sys_email:
            return SystemSlot.Email
        case SlotWebchatMap.sys_phone:
            return SystemSlot.Phone
        case SlotWebchatMap.sys_omniuserid:
            return SystemSlot.OmniUserId
        case SlotWebchatMap.sys_extuserid:
            return SystemSlot.ExtUserId
        default:
            return field
    }
}
